export const ELEVATION = {
    light: {
        card: '0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.05)',
        raised: '0 4px 14px rgba(16, 24, 40, 0.08), 0 1px 3px rgba(16, 24, 40, 0.06)',
        overlay: '0 12px 32px rgba(16, 24, 40, 0.14), 0 2px 6px rgba(16, 24, 40, 0.06)',
        control: '0 1px 1px rgba(16, 24, 40, 0.04)',
    },
    dark: {
        card: '0 1px 2px rgba(0, 0, 0, 0.5)',
        raised: '0 4px 14px rgba(0, 0, 0, 0.55), 0 1px 3px rgba(0, 0, 0, 0.5)',
        overlay: '0 12px 32px rgba(0, 0, 0, 0.6), 0 2px 6px rgba(0, 0, 0, 0.5)',
        control: 'none',
    },
};
/** Focus (§4): keyboard ring = 2px primary at 2px offset; focused input = 1px brand border + 3px tint ring. */
export const FOCUS = { ringWidth: 2, ringOffset: 2, inputRingWidth: 3 };
//# sourceMappingURL=elevation.js.map